module.exports = __webpack_public_path__ + "static/media/sbp.20ace504.png";